import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import {Ilan} from 'app/model/ilan.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import {IlanTeklifDto} from '../model/ilanTeklifDto';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {IlanModel} from '../model/spring-model/Ilan.model';
import {AuthenticationService} from './authentication.service';


@Injectable()
export class IlanService {
  public _ilanDetaySubjectS: BehaviorSubject<IlanModel>;
  constructor(private https: HttpClient, private  authService: AuthenticationService) {
    this._ilanDetaySubjectS = <BehaviorSubject<IlanModel>>new BehaviorSubject(undefined);
  }
  getIlanDetaySubjectS() {
    return this._ilanDetaySubjectS.asObservable();
  }

  sendIlanDetayMessageS(ilan: IlanModel) {
    this._ilanDetaySubjectS.next(Object.assign({}, ilan));
  }

  public deleteFile(filename: string) {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'upload/' + filename;
    return this.https.delete<IlanModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }

  getIlanListFilterS(ilanDurum: String , page: number , size: number ): Observable<HttpResponse<IlanModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan/ilanDurum/' + ilanDurum.toString() + '/page/' + page + '/size/' + size;
    return this.https.get<IlanModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
  getGaleriCountByIlanDurum(ilanDurum: String ): Observable<HttpResponse<number>> {
     const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan/count/' + ilanDurum.toString();
     return this.https.get<number>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
  removeIlanS(ilanPk: number): Observable<HttpResponse<boolean>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan/' + ilanPk;
    return this.https.delete<boolean>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }

  ilanTeklifVerS(ilanDto: IlanTeklifDto): Observable<HttpResponse<Ilan>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan/teklif-yap';
    return this.https.post<Ilan>(apiURL, ilanDto, {observe: 'response', headers: this.authService.getHeader()});
  }
  updateIlanS(ilan: IlanModel): Observable<HttpResponse<Ilan>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan';
    return this.https.put<Ilan>(apiURL, ilan, {observe: 'response', headers: this.authService.getHeader()});
  }
  createIlan(ilan: IlanModel): Observable<HttpResponse<Ilan>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan';
    return this.https.post<Ilan>(apiURL, ilan, {observe: 'response', headers: this.authService.getHeader()});
  }
  getIlanById(id: number): Observable<HttpResponse<IlanModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan/' + id;
    return this.https.get<IlanModel>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
  deleteIlanFoto (ilanFotoId: number): Observable<HttpResponse<boolean>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ilan/ilanFoto/' + ilanFotoId;
    return this.https.delete<boolean>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/ilan.service.ts